import { cantBeAnalysedText, UnusableTelemetryError } from '@pitbrain/shared'

export const unusableReasonOf = (error: unknown): string | null =>
  error instanceof UnusableTelemetryError ? error.message : null

export const unusableSessionMessage = (error: unknown): string | null => {
  const reason = unusableReasonOf(error)
  return reason === null ? null : cantBeAnalysedText(reason)
}
